import React from 'react';
import * as types from '../api/types';
import { OUTBOX_STATUS_CLASSES, OUTBOX_STATUS_LABELS, PROVIDER_STATUS_LABELS } from '../pages/settings/notificationUi';

export function OutboxStatusBadge({ status }: { status: types.OutboxStatus }) {
  return (
    <span className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ${OUTBOX_STATUS_CLASSES[status]}`}>
      {OUTBOX_STATUS_LABELS[status]}
    </span>
  );
}

export function ProviderStatusBadge({ status }: { status: types.ProviderConfigStatus | null }) {
  const cls =
    status === 'VERIFIED' ? 'bg-green-50 text-green-800' : status === 'FAILED' ? 'bg-red-50 text-red-800' : 'bg-yellow-50 text-yellow-800';
  return (
    <span className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ${cls}`} data-testid="provider-status">
      {status ? PROVIDER_STATUS_LABELS[status] : 'Not connected'}
    </span>
  );
}

/** On / Off badge for a message type (template). */
export function TemplateStatusBadge({ active }: { active: boolean }) {
  return (
    <span
      className={`inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ${active ? 'bg-green-50 text-green-800' : 'bg-gray-100 text-gray-700'}`}
    >
      {active ? 'On' : 'Off'}
    </span>
  );
}
